module.exports = __webpack_public_path__ + "img/c.d9f8cff4.png";